._container_1bjds_1 {
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: #d6e6fe; }
  ._containerDark_1bjds_8 {
    border-color: #9c9ca2; }
